import { pDebounce } from '@exodus/basic-utils';
import getEventPayload, { EventId } from '../telemetry-events.js';
const createExchangeAnalyticsPlugin = (params) => {
    const { analytics, exchangeAssets, trackAssetSearchUnavailableDelay = 200 } = params;
    let subscriptions = [];
    const trackAssetSearchUnavailable = pDebounce(({ direction, query }) => {
        const eventPayload = getEventPayload(EventId.ExchangeConfigureAssetSearchUnavailable, {
            toOrFrom: direction,
            content: query,
        });
        void analytics.track(eventPayload);
    }, trackAssetSearchUnavailableDelay);
    const onStart = () => {
        exchangeAssets.on('empty-search', trackAssetSearchUnavailable);
        const unsubscribeEmptySearch = () => exchangeAssets.off('empty-search', trackAssetSearchUnavailable);
        subscriptions = [unsubscribeEmptySearch];
    };
    const onStop = () => {
        subscriptions.forEach((unsubscribe) => unsubscribe());
        subscriptions = [];
    };
    return { onStart, onStop };
};
const exchangeAnalyticsPluginDefinition = {
    id: 'exchangeAnalyticsPlugin',
    type: 'plugin',
    factory: createExchangeAnalyticsPlugin,
    dependencies: ['analytics', 'exchangeAssets'],
    public: false,
};
export default exchangeAnalyticsPluginDefinition;
